// @flow

import baseSchema, {
  findDependentAlertTypeSchema,
  findSchemaRequired,
  baseUiSchema,
} from "./base-schema";
import type { Schemas } from "./types";

export const schema = (schema: ?Object) => {
  const typeSchema = findDependentAlertTypeSchema(
    schema,
    "HOURS_LOST_OVER_AVG_WCH_IN_Y_PERIOD_OVER_Z_PERIOD_TYPE",
  );

  return {
    ...baseSchema,

    properties: {
      ...baseSchema.properties,
      hoursLostOverAvgWchInYPeriodOverZPeriodType: {
        required: findSchemaRequired(typeSchema, "hoursLostOverAvgWchInYPeriodOverZPeriodType"),
        title: "Hours Lost Over Avg Wch In Y Period Over Z Period Type",
        properties: {
          hours: {
            type: "integer",
            title: "Hours",
          },
          period: {
            type: "integer",
            title: "Period",
          },
          periodType: {
            title: "Period Type",
            type: "string",
            oneOf: [
              { title: "Days", const: "D" },
              { title: "Months", const: "M" },
              { title: "Weeks", const: "W" },
            ],
          },
        },
        type: "object",
      },
    },
  };
};

export const uiSchema = (t: (s: string) => string) => baseUiSchema(t);

const schemas: Schemas = {
  schema,
  uiSchema,
};

export default schemas;
